import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcSwitch } from 'components/MprcSwitch';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IAdvFilterPickerProps, IAdvFilterResult } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const SwitchPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<boolean>(true);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected != null) {
            const newFilter: IAdvFilterResult = {
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${t(selected ? "Literal.Yes" : "Literal.Not", { ns: "shared" })}`,
                value: selected,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            };
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <MprcSwitch
                    color="warning"
                    label={filter.displayName}
                    autoFocus
                    checked={selected}
                    onChange={() => setSelected(!selected)}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
